import React, { FunctionComponent } from 'react';

import { Attachment } from '@api/v4/attachments/attachmentTypes';
import BrightcovePlayer from '@components/video/brightcove_player/main';

export const BrightcoveVideoPreview: FunctionComponent<Attachment> = ({
  brightcove_account_id: brightcoveAccountId,
  brightcove_video_id: brightcoveVideoId
}) => (
  <BrightcovePlayer
    attrs={{
      id: "advanced-video",
      className: "m-show-full-size-display",
      'data-private': true,
      'data-testid': "asset-preview--brightcove-player"
    }}
    accountID={brightcoveAccountId}
    videoID={brightcoveVideoId}
    playerID="default"
  />
);
